# common wireups go here
#global name space
if not window.gs?
  window.gs = {}

gs.common = {} #place to store globals without polluting global space
gs.wireup = {}

gs.colors = ["#A1C110", "#134F81", "#00AEEF", "#615e5d", "#850B80", "#f09000", "#7F912D", "#6697C0", "#966B2F", "#C260BE", "#CBE06F", "#234561", "#E4B371", "#641F61"]

#init
$(document).ready ->
  gs.wireup.general()
  gs.wireup.home()  if $("body.home")
  gs.wireup.contact()  if $("body.contact")
  gs.wireup.page()  if $("body.page")

gs.wireup.fullscreen_toggle = ->
  $("body").toggleClass "fullscreen"
  $(".container").toggleClass "container-fluid"

  #adjust height of container
  $(".wrapper > .container").css height: "auto"
  #$("body.fullscreen .wrapper > .container").outerHeight $(window).outerHeight() - $(".navbar").outerHeight()

  #adjust fluid of lobby
  $("#lobby").removeClass("row-fluid").addClass "row"
  $("body.fullscreen #lobby").removeClass("row").addClass "row-fluid"

  #adjust spans of lobby option
  $("#lobby .span6").removeClass("span6").addClass "span9"
  $("body.fullscreen #lobby .span9").removeClass("span9").addClass "span6"

  $(".site_map").toggle()
  $("#nav_breadcrumbs").toggle()
  $("#mode_select").toggle()

  #Trigger resize code for grids, graphs, etc.
  $(window).resize()

  false

#wireups
gs.wireup.general = ->
  #find all data_list uls and add a clickable button
  $(".data_list").append "<li class=\"data_list_open_close\">X</li>"
  $(".data_list_open_close").click ->
    $(this).parent().toggleClass "data_list_open"

  #wireup fullscreen click
  $(".fullscreen_toggle").click gs.wireup.fullscreen_toggle

  # wireup  morse test
  $("#custom_morse_test").click ->
    $("#custom_morse").addClass("custom_morse_live").delay(500).queue (next) ->
      $(this).removeClass "custom_morse_live"
      next()

  #wireup tabs
  $(".nav-tabs a").click (e) ->
    e.preventDefault()
    $(this).tab "show"
    $('body').scrollspy "refresh"

  $(".nav-tabs a:first").click

  #wireup read mores
  $(".gs_read_more_a").click (e) ->
    $(this).hide().nextAll(".gs_read_more_p").show()
    e.preventDefault()

gs.wireup.home = ->
  # slide show in intro section of home page
  gs.common.home_slide_count = 0
  gs.common.home_slide_names = ["school", "industry", "home", "business"]
  gs.common.home_slide = setInterval((->
    gs.common.home_slide_count -= 340
    $("#home_slide").css backgroundPosition: gs.common.home_slide_count + "px -20px"
    name = (gs.common.home_slide_count / -340) % gs.common.home_slide_names.length
    $(".home_slide_name").text gs.common.home_slide_names[name]), 5000)

gs.wireup.contact = ->

  # qr codes
  $(".spy_photo").click ->
    $(this).toggleClass "qr"

gs.scroll_to = (target) ->
  $target = $(target)
  $("html, body").stop().animate
    scrollTop: $target.offset().top
  , 900, "swing", ->
    window.location.hash = target

gs.wireup.page = ->

  #function to wireup tooltips (if this works the first time but not later its because KO's 'if' is redrawing html and destroying the attachedjs)
  $('[rel=tooltip]').tooltip();

  #dynamically generate navigation menu
  content = $(".content")
  if content.height() > 800

    #dynamically generate menu
    html = ""

    $(".content").first().find("h1,h2,h3").each (idx, header) ->
      header = $(header)
      curr_id = header.attr "id"
      node_name = header.prop "nodeName" # "H1", "H2" etc
      unless curr_id?
        # Need to add an id for any header that does not have one already.
        curr_id = "dyn_menu_" + idx
        header.attr id: curr_id

      if node_name == "H3"
        line = "<li><a href='##{curr_id}'>#{header.text()}</a></li>"
      else
        line = "<li><b><a href='##{curr_id}'>#{header.text()}</a></b></li>"

      html += line
      $(this).wrap("<a href='#" + curr_id + "' class='hover_link'></a>")

    $("#dynamic_menu").html html
    $("body").scrollspy offset: 130

  # Smooth Scrolling
  $($("a[href^=\"#?\"]:not(.accordion-toggle):not(.carousel-control)")).on "click", (e) ->
    e.preventDefault()
    target = @hash
    gs.scroll_to(target)

# Set up animation framework
# shim layer with setTimeout fallback
window.requestAnimFrame = (->
  window.requestAnimationFrame or window.webkitRequestAnimationFrame or window.mozRequestAnimationFrame or (callback) ->
    window.setTimeout callback, 1000 / 60
)()

# Array reduce shim for IE
if "function" isnt typeof Array::reduce
  Array::reduce = (callback, value = undefined) ->

    # At the moment all modern browsers, that support strict mode, have
    # native implementation of Array.prototype.reduce. For instance, IE8
    # does not support strict mode, so this check is actually useless.
    throw new TypeError("Array.prototype.reduce called on null or undefined")  if null is this or "undefined" is typeof this
    throw new TypeError(callback + " is not a function")  if "function" isnt typeof callback
    index = undefined
    length = @length >>> 0
    isValueSet = value?

    index = 0
    while length > index
      if @hasOwnProperty(index)
        if isValueSet
          value = callback(value, this[index], index, this)
        else
          value = this[index]
          isValueSet = true
      ++index
    throw new TypeError("Reduce of empty array with no initial value")  unless isValueSet
    value

unless Array::map
  Array::map = (fun, thisArg=undefined) -> #, thisArg
    throw new TypeError()  if this is undefined or this is null
    t = Object(this)
    len = t.length >>> 0
    throw new TypeError()  if typeof fun isnt "function"
    res = new Array(len)
    i = 0

    while i < len

      # NOTE: Absolute correctness would demand Object.defineProperty
      #       be used.  But this method is fairly new, and failure is
      #       possible only if Object.prototype or Array.prototype
      #       has a property |i| (very unlikely), so use a less-correct
      #       but more portable alternative.
      res[i] = fun.call(thisArg, t[i], i, t)  if i of t
      i++
    res

gs.common.defer = (func) =>
   deferEvaluation: true
   read: func


class LoadingMgr
  constructor: (@building) ->
    @loading_pc = null
    @req_ctr = 0  # If downloads in progress, number of downloads to do.
    @req_done = 0 # If downloads in progress, number done.

    @other_requests =
      "auth": {loading: false, pc: 10, done: false}
      "sensors": {loading: false, pc: 20, done: false}
      "live_conn": {loading: false, pc: 10, done: false}
      "live_data": {loading: false, pc: 20, done: false}
      "inst_get_cfg": {loading: false, pc: 20, done: false}
      "inst_save": {loading: false, pc: 20, done: false}
      "inst_nodes": {loading: false, pc: 20, done: false}
      "login": {loading: false, pc: 10, done: false}
      "profile": {loading: false, pc: 20, done: false}
      "orgs": {loading: false, pc: 20, done: false}
      "org_detail": {loading: false, pc: 20, done: false}

    @loading = ko.observable false


  update_loading: () ->
    # Update the NProgress loading bar based on how far through loading we think we are.

    req_loading = false
    req_loading_tot = 0
    req_loading_pc = 0
    for own req, deets of @other_requests
      {loading:loading, pc:pc, done:done} = deets
      if loading and not done
        req_loading = true

      if loading
        req_loading_tot += pc / 100.0
        if done
          req_loading_pc += pc / 100.0

    unless (req_loading or @req_ctr != @req_done)
      # Not currently loading
      if @loading_pc?
        NProgress.done()
        # Clear the loading info.
        @loading_pc = null
        @req_ctr = @req_done = 0 # All outstanding requests done.
        for req, deets in @other_requests
          loading = done = false
        # Let Graphs refresh again.
        if @loading()
          @loading false

      return

    # Currently loading
    unless @loading_pc?
      @loading_pc = 0
      NProgress.start()
      return

    desired_loading_pc = req_loading_pc

    if @req_ctr > 0
      req_pc = @req_done / @req_ctr
      req_pc *= (1.0 - req_loading_tot)
      desired_loading_pc += req_pc

      if @req_ctr == @req_done
        data_loading = false
      else
        data_loading = true

      if data_loading != @loading()
        @loading data_loading

    if NProgress.status + 0.05 >= desired_loading_pc
      # Don't change the bar (to decrease it) just leave it as-is
      return
    else
      @loading_pc = desired_loading_pc
      NProgress.set(@loading_pc)

  show_loading: (req) ->
    unless @other_requests[req]
      # Unknown request type. Adding to list.
      console?.log "LoadingMgr: Adding new request type #{req} to list."
      @other_requests[req] = {loading: false, pc: 20, done: false}

    @other_requests[req].loading = true
    @other_requests[req].done = false
    @update_loading()

    setTimeout =>
      @done_loading(req)
    , 5000

  done_loading: (req) ->
    return unless @other_requests[req].loading

    @other_requests[req].done = true
    @update_loading()

  load_data: ()->
    @req_ctr += 1

  load_done: ()->
    @req_done += 1
    @update_loading()


gs.loading_mgr = new LoadingMgr()
# Add a couple of handy shortcuts.
gs.show_loading = (args...) -> gs.loading_mgr.show_loading(args...)
gs.done_loading = (args...) -> gs.loading_mgr.done_loading(args...)
